import React, { Component } from 'react';
import { Table, ButtonToolbar, ButtonGroup, Button } from 'react-bootstrap/lib';
import Api from './../../Global/Modules/Api';

const FETCH_URL = 'api/courses/institutions'

class TableTabs extends Component {
    constructor() {
        super();
        this.state = {
            institutionsButtons: [],
            courses: [],
            displayTable: 'none',
            emptyTable: 'none',
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0
            }
        }
        this.handleClick = this.handleClick.bind(this);
        this.handleTabClick = this.handleTabClick.bind(this);
    }
    componentDidMount() {
        var that = this;
        Api.GetApi(FETCH_URL).then((data) => {
            let buttons = data.institutions.map(function (item, index) {
                if (index === 0) {
                    that.setState({ firstbutton: item.code })
                }
                return <Button className={index === 0 ? "Selected" : ""} key={item.code} onClick={(e) => that.handleClick(item.code, e)}>{item.value}</Button>
            })
            this.setState({ institutionsButtons: buttons });
            this.handleClick(this.state.firstbutton);

        });
    }

    handleTabClick(e) {
        const FETCH_URL = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        Api.GetTableApi(FETCH_URL, this.handleTabClick).then(response => {
            if (response.pagination.totalCount === 0) {
                this.setState({ displayTable: "none" })
                this.setState({ emptyTable: "block" })
            } else {
                this.setState({ displayTable: "block" })
                this.setState({ emptyTable: "none" })
            }
            this.setState({ pagination: response.pagination })
            return response.data.json()
        }).then(objectData => {
            if (objectData !== undefined) {
                let courses = objectData.courses.map(function (item, index) {
                    return <tr key={item.id}>
                        <td>{item.institution}</td>
                        <td>{item.name}</td>
                        <td>{item.content}</td>
                        <td>{item.level}</td>
                        <td>{item.points}</td>
                        <td><a href={item.website}>website</a></td>
                    </tr>
                })
                this.setState({ courses: courses });
            }
        })
    }

    handleClick(Id, event) {
        const FETCH_URL_INSTITUTION = 'https://constructor.wefo020.e-f.nl/api/courses/institution/' + Id;
        Api.GetTableApi(FETCH_URL_INSTITUTION, this.handleTabClick).then(response => {
            if (response.pagination.totalCount === 0) {
                this.setState({ displayTable: "none" })
                this.setState({ emptyTable: "block" })
            } else {
                this.setState({ displayTable: "block" })
                this.setState({ emptyTable: "none" })
            }
            this.setState({ pagination: response.pagination })
            return response.data.json()
        }).then(objectData => {
            if (objectData !== undefined) {
                let courses = objectData.courses.map(function (item, index) {
                    return <tr key={item.id}>
                        <td>{item.institution}</td>
                        <td>{item.name}</td>
                        <td>{item.content}</td>
                        <td>{item.level}</td>
                        <td>{item.points}</td>
                        <td><a href={item.website}>website</a></td>
                    </tr>
                })
                this.setState({ courses: courses });
            }
        })
    }

    render() {
        return (
            <div>
                <ButtonToolbar>
                    <ButtonGroup>
                        {this.state.institutionsButtons}
                    </ButtonGroup>
                </ButtonToolbar>
                <div style={{ display: this.state.displayTable }}>
                    <div>Resultaten  {(this.state.pagination.pageSize == '0' || this.state.pagination.pageSize > this.state.pagination.totalCount) ? this.state.pagination.totalCount : this.state.pagination.pageSize} van {this.state.pagination.totalCount}</div>
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>Instituut</th>
                                <th>Naam cursus</th>
                                <th>Inhoud</th>
                                <th>Niveau</th>
                                <th>KE/EE punten</th>
                                <th>Website</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.courses}
                        </tbody>
                    </Table>
                    <div className="paginationStyling">
                        <div style={{ float: 'left' }}>
                            {this.state.pagination.prevButton}
                        </div>
                        <div style={{ float: 'center' }}>
                            Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                        </div>
                        <div style={{ float: 'right' }}>
                            {this.state.pagination.nextButton}
                        </div>
                    </div>
                </div>
                <div style={{ display: this.state.emptyTable }}>
                    <br /> <br />
                    Er zijn geen gegevens beschikbaar
                </div>
            </div>
        );
    }
}

export default TableTabs;



// WEBPACK FOOTER //
// ./src/components/Global/Modules/TableTabs.js